<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\nbackground: transparent ;\nbackground-image: url(\"https:\/\/api.arair.ir\/storage\/asset\/bg.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\n"' class="container-fluid text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/contents\/2NbiMfVloaOtdWP3WjfqS2dC5Mbhk95mPlWgsWGK.png","alt":"mix it web"},...{}}' :style='"height:300px;\nobject-fit:contain;"' class="col-12  text-center" ></m-img><m-h4 v-bind='{...{},...{}}' :style='""' class="col" >
                <template #default>لطفا مراحل زیر  را کامل کنید .   </template>
                </m-h4><m-products-305 v-bind='{...{"paginate":false,"perPage":12,"productCardName":"mProductCard208_request","singleCategory":"\u062e\u062f\u0645\u0627\u062a-\u0632\u06cc\u0628\u0627\u06cc\u06cc","cardClass":"col-lg-4 my-2 rounded rounded-9"},...{}}' :style='""' class="col-12 text-center m-products-305 pb-5" ></m-products-305></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mProducts305 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products305/Products305';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mH4,mProducts305 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
